import React, {createContext, useContext, useState} from "react";

import {useAuth} from "../auth/auth";
import {readClientRequest, readClientsRequest} from "../clients/clients-actions";

const userClientsDataContext = createContext();
const useUserClientsData = () => useContext(userClientsDataContext);

const useProvideUserClientsData = () => {

    const auth = useAuth();

    const [userClientsData, setUserClientsData] = useState([]);

    return {
        userClientsData,
        requestUserClientsData: async () => {
            if (auth.userType === "admin") {
                try {
                    const res = await readClientsRequest();
                    if (Array.isArray(res.data.payload)) {
                        setUserClientsData(res.data.payload);
                    }
                } catch (e) {
                    console.log(e);
                }
            }
            else {
                try {
                    const res = await readClientRequest(auth.selectedClient);
                    if (res.data && res.data.payload) {
                        setUserClientsData([res.data.payload]);
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        },
        updateUserClientData: newClient => {
            const clientIndex = newClient && userClientsData.findIndex(client => client._id === newClient._id);
            if (!newClient || clientIndex === -1) return;
            let newUserClientsData = [...userClientsData];
            newUserClientsData[clientIndex] = newClient;
            setUserClientsData(newUserClientsData);
        },
        addUserClientData: newClient => newClient && (userClientsData.findIndex(client => client._id === newClient._id)) === -1 && setUserClientsData([...userClientsData, newClient]),
        deleteUserClientData: deletedClientId => {
            const clientIndex = deletedClientId && userClientsData.findIndex(client => client._id === deletedClientId);
            if (!deletedClientId || clientIndex === -1) return;
            setUserClientsData(() => {
                let newUserClientsData = [...userClientsData];
                newUserClientsData.splice(clientIndex, 1);
                return newUserClientsData;
            });
        }
    }
};

const ProvideUserClientsData = ({children}) => {
    const userClientsData = useProvideUserClientsData();
    return (
        <userClientsDataContext.Provider value={userClientsData}>
            {children}
        </userClientsDataContext.Provider>
    );
};

export {
    ProvideUserClientsData,
    useUserClientsData
}